/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import { useGLTF, useTexture } from "@react-three/drei";
import model from "./Comercial_V9.glb";
import opacidadeVaso from "./materials/Vaso2_Opacity.jpg";
import sphereBackground from "./materials/canary_wharf_4k.png";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);
  const vasoOpacidade = useTexture(opacidadeVaso);
  const backgroundSphere = useTexture(sphereBackground);

  useEffect(() => {
    // console.log(materials);
    materials.Elevadores.normalMap = null;
    // materials["Monstera01"].transparent = true;
    // materials["Monstera01"].alphaMap = vasoOpacidade;
    // materials["Monstera01"].alphaMap.flipY = true;
    // materials["Monstera02"].transparent = true;
    // materials["Monstera02"].alphaMap = vasoOpacidade;
    // materials["Monstera02"].alphaMap.flipY = true;
  }, []);
  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh visible position={[0, 0, 0]} rotation={[0, 0, 0]}>
        <sphereGeometry attach="geometry" args={[60, 40, 40]} />
        <meshBasicMaterial
          attach="material"
          color="white"
          roughness={0.1}
          metalness={1}
          map={backgroundSphere}
          side={THREE.BackSide}
        />
      </mesh>
      <group name="Scene">
        <mesh
          name="Monstera01"
          castShadow
          receiveShadow
          geometry={nodes.Monstera01.geometry}
          material={materials.Monstera01}
          material-alphaMap={vasoOpacidade}
          material-alphaMap-flipY={false}
          material-transparent
          position={[-0.86, 0.21, 8.22]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="Monstera02"
          castShadow
          receiveShadow
          geometry={nodes.Monstera02.geometry}
          material={materials.Monstera02}
          material-alphaMap={vasoOpacidade}
          material-alphaMap-flipY={false}
          material-transparent
          position={[2.17, 0.21, 8.17]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="MesasTrabalho"
          castShadow
          receiveShadow
          geometry={nodes.MesasTrabalho.geometry}
          material={materials.MesaTrabalho}
          position={[-0.4, 4.63, 1.39]}
        />
        <mesh
          name="BancoCurvo"
          castShadow
          receiveShadow
          geometry={nodes.BancoCurvo.geometry}
          material={materials.BancoCurvo}
          position={[2.2, 0.22, 6.29]}
          rotation={[Math.PI / 2, 0, -0.03]}
        />
        <mesh
          name="Bancos"
          castShadow
          receiveShadow
          geometry={nodes.Bancos.geometry}
          material={materials.Bancos}
          position={[0.04, 0.41, 5.54]}
          rotation={[0, Math.PI / 2, 0]}
        />
        <mesh
          name="CadeiraGir01"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraGir01.geometry}
          material={materials.CadGir01}
          position={[0.37, 4.21, 1.19]}
        />
        <mesh
          name="MesaReuniao"
          castShadow
          receiveShadow
          geometry={nodes.MesaReuniao.geometry}
          material={materials.MesaReuniao}
          position={[0.81, 4.82, -7.47]}
          scale={0.06}
        />
        <mesh
          name="CadeiraGir02"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraGir02.geometry}
          material={materials.CadGir02}
          position={[0.37, 4.21, -0.3]}
        />
        <mesh
          name="CadeiraGir03"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraGir03.geometry}
          material={materials.CadGir03}
          position={[0.37, 4.21, 2.82]}
        />
        <mesh
          name="CadeiraGir04"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraGir04.geometry}
          material={materials.CadGir04}
          position={[-1.36, 4.21, 1.28]}
          rotation={[-Math.PI, 0, -Math.PI]}
        />
        <mesh
          name="CadeiraGir05"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraGir05.geometry}
          material={materials.CadGir05}
          position={[-1.36, 4.21, 2.77]}
          rotation={[-Math.PI, 0, -Math.PI]}
        />
        <mesh
          name="CadeiraGir06"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraGir06.geometry}
          material={materials.CadGir06}
          position={[-1.36, 4.21, -0.35]}
          rotation={[-Math.PI, 0, -Math.PI]}
        />
        <mesh
          name="LuminariaAnel"
          castShadow
          receiveShadow
          geometry={nodes.LuminariaAnel.geometry}
          material={materials.LumAnel}
          position={[0.33, 3.57, 6.56]}
        />
        <mesh
          name="CadeiraPipe01"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraPipe01.geometry}
          material={materials.CadPipe01}
          position={[1.9, 4.63, -7.45]}
          rotation={[Math.PI, 0, Math.PI]}
        />
        <mesh
          name="CadeiraPipe02"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraPipe02.geometry}
          material={materials.CadPipe02}
          position={[0.93, 4.63, -8.68]}
          rotation={[Math.PI, -1.52, Math.PI]}
        />
        <mesh
          name="CadeiraPipe03"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraPipe03.geometry}
          material={materials.CadPipe03}
          position={[0.8, 4.63, -6.26]}
          rotation={[0, 1.46, 0]}
        />
        <mesh
          name="CadeiraPipe04"
          castShadow
          receiveShadow
          geometry={nodes.CadeiraPipe04.geometry}
          material={materials.CadPipe04}
          position={[-0.44, 4.63, -7.42]}
          rotation={[0, -0.03, 0]}
        />
        <mesh
          name="ArqEspaco"
          castShadow
          receiveShadow
          geometry={nodes.ArqEspaco.geometry}
          material={materials.ArqEspaco}
          position={[-1.27, 0, 7.91]}
        />
        <mesh
          name="ArqMezanino"
          castShadow
          receiveShadow
          geometry={nodes.ArqMezanino.geometry}
          material={materials.ArqMezanino}
          position={[-1.27, 3.9, 2.98]}
        />
        <mesh
          name="ArquibancadaLuminarias"
          castShadow
          receiveShadow
          geometry={nodes.ArquibancadaLuminarias.geometry}
          material={materials.ArquibanLum}
          position={[-0.8, 0.87, -4.65]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          name="JanelasEscada"
          castShadow
          receiveShadow
          geometry={nodes.JanelasEscada.geometry}
          material={materials.JanEscada}
          position={[2.1, 0.18, 3.8]}
        />
        <mesh
          name="DivTV"
          castShadow
          receiveShadow
          geometry={nodes.DivTV.geometry}
          material={materials.DivTV}
          position={[1.7, 6.15, -5.68]}
        />
        <mesh
          name="Vidro"
          castShadow
          receiveShadow
          geometry={nodes.Vidro.geometry}
          material={materials.Vidro}
          material-transparent={true}
          material-depthWrite={false}
          position={[1.7, 6.15, -5.68]}
        />
        <mesh
          name="Monitores"
          castShadow
          receiveShadow
          geometry={nodes.Monitores.geometry}
          material={materials.Monitores}
          position={[-0.33, 5.06, 2.82]}
          rotation={[0, 1.57, 0]}
        />
        <mesh
          name="Teclados"
          castShadow
          receiveShadow
          geometry={nodes.Teclados.geometry}
          material={materials.Teclados}
          position={[-0.51, 4.91, 1.25]}
        />
        <mesh
          name="VasoCostela"
          castShadow
          receiveShadow
          geometry={nodes.VasoCostela.geometry}
          material={materials.VasoCostela}
          position={[-1.6, 0, 0.59]}
        />
        <mesh
          name="SonexNuvem"
          castShadow
          receiveShadow
          geometry={nodes.SonexNuvem.geometry}
          material={materials.Sonex}
          position={[-0.37, 6.93, 1.04]}
        />
        <mesh
          name="ForroReuniao"
          castShadow
          receiveShadow
          geometry={nodes.ForroReuniao.geometry}
          material={materials.Material}
          position={[2.58, 8, -5.97]}
        />
        <mesh
          name="PainelRipas"
          castShadow
          receiveShadow
          geometry={nodes.PainelRipas.geometry}
          material={materials.PainelRipas}
          position={[1.28, 1.95, 0.65]}
        />
        <mesh
          name="Elevadores"
          castShadow
          receiveShadow
          geometry={nodes.Elevadores.geometry}
          material={materials.Elevadores}
          position={[-2.27, 1.13, 3.57]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
